class Modale {
    constructor() {
        this.forms = document.querySelectorAll('.js-select-package-form');
        if (this.forms) {
            this.forms.forEach((form) => {
                this.bind(form);
            });
        }
    }

    // eslint-disable-next-line class-methods-use-this
    bind(item) {
        if (parseInt(item.dataset.multipleVariations, 10)) {
            const inputs = [...item.querySelectorAll('.variation-input')];
            const checked = inputs.some((el) => el.checked);
            const submitButton = item.querySelector("button[type='submit'].button");
            if (!checked && submitButton) {
                submitButton.disabled = true;
            }

            inputs.forEach((input) => {
                input.addEventListener('click', (e) => {
                    if (e.target.checked) {
                        submitButton.disabled = false;
                    }
                });
            });
        }
    }
}

export default Modale;
